import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Star } from "../../../../app-constants";
import Awads from "../../home/awads";
import { Link } from "gatsby";

function Awardsrecognitions(props) {
  let className = "tekrevol_awards p-100";
  if (props.bg) {
    className = "tekrevol_awards gery tekrevol_gray_bg p-100";
  }
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={7}
            xl={7}
            xxl={7}
            className="tekrevol_awards_title mt-auto mb-auto"
          >
            <div className="example" data-text="Winning Awards">
              <h3 className="h3_head">Awards & Recognitions</h3>
            </div>
            <p>{props.txt}</p>
            <Link
              to="https://clutch.co/profile/tekrevol#reviews"
              className="border_btn"
              target="_blank"
              aria-label="TekRevol Reviews"
              rel="nofollow"
            >
              Check Reviews
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={5}
            xl={5}
            xxl={5}
            className="text-end mt-auto"
          >
            <div className="tekrevol_rating">
              <span>75+ reviews on clutch</span>
              <div className="tekrevol_rating_numbers">4.8</div>
              <div className="tekrevol_star">{Star}</div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <Awads content={props.content === false ? false : true} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Awardsrecognitions;
